/**
 * Mothers Feature Routes
 */
import type { RouteRecordRaw } from 'vue-router';
import i18next from 'i18next';

export const mothersRoutes: RouteRecordRaw[] = [
  {
    path: '/mothers',
    name: 'mothers',
    component: () => import('./views/MothersListView.vue'),
    meta: {
      title: () => i18next.t('nav.mothers'),
      requiredEntitlement: 'MOTHER_MANAGEMENT',
    },
  },
  {
    path: '/mothers/:id',
    name: 'mother-profile',
    component: () => import('./views/MotherProfileOverview.vue'),
    meta: {
      title: () => i18next.t('mother.profile.title'),
      requiredEntitlement: 'MOTHER_MANAGEMENT',
      breadcrumbs: [
        { label: () => i18next.t('nav.mothers'), to: '/mothers' },
        { label: () => i18next.t('mother.profile.title') },
      ],
    },
  },
];
